import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { renameContentLibraryFileRequested } from 'features/content-library/actions';

export function* renameContentLibraryFileSaga(
  action: ReturnType<typeof renameContentLibraryFileRequested>
) {
  yield call(SignalingSocket.send, { event: 'renameLibraryFile', data: action.payload });
}
